// extracted by mini-css-extract-plugin
export var compactFilters = "_e3-4";
export var detailImage = "_e3-1";
export var dropdownContainer = "_e3-2";
export var imageContainer = "_e3-0";
export var selectedCard = "_e3-3";